import { baseApi } from "./base.api";

export const patientReferrelApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchReferrelPatients: build.query({
      query: (params) => ({ url: "/patient-referrel/fetch", method: "GET", params }),
      providesTags: ["ReferralPatient"],
    }),
    fetchTrashedReferrelPatients: build.query({
      query: (params) => ({ url: "/patient-referrel/fetch/trashed", method: "GET", params }),
      providesTags: ["ReferralPatient"],
    }),
    fetchReferredReferrelPatientsAll: build.query({
      query: () => ({ url: "/patient-referrel/fetch/all", method: "GET" }),
      providesTags: ["ReferralPatient"],
    }),
    
    fetchPatientById: build.query({
      query: (id) => ({ url: `/patient-referrel/fetch/${id}`, method: "GET" }),
      providesTags: ["ReferralPatient"],
    }),
    createPatientReferral: build.mutation({
      query: (body) => ({ url: "/patient-referrel/create", method: "POST", body }),
      invalidatesTags: ["ReferralPatient"],
    }),
    updatePatientReferral: build.mutation({
      query: ({ id, body }) => ({ url: `/patient-referrel/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["ReferralPatient"],
    }),
    restorePatientReferral: build.mutation({
      query: (id) => ({ url: `/patient-referrel/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["ReferralPatient"],
    }),
    bulkRestoreReferrelPatients: build.mutation({
      query: (body) => ({ url: "/patient-referrel/bulk-restore", method: "POST", body }),
      invalidatesTags: ["ReferralPatient"],
    }),
    deletePatientReferral: build.mutation({
      query: (id) => ({ url: `/patient-referrel/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["ReferralPatient"],
    }),
    bulkDeleteReferrelPatients: build.mutation({
      query: (body) => ({ url: "/patient-referrel/bulk-delete", method: "POST", body }),
      invalidatesTags: ["ReferralPatient"],
    }),
    destroyPatientReferral: build.mutation({
      query: (id) => ({ url: `/patient-referrel/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["ReferralPatient"],
    }),
    bulkDestroyReferrelPatients: build.mutation({
      query: (body) => ({ url: "/patient-referrel/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["ReferralPatient"],
    }),
  }),
});

export const {
  useFetchReferrelPatientsQuery,
  useFetchTrashedReferrelPatientsQuery,
  useFetchPatientByIdQuery,
  useCreatePatientReferralMutation,
  useUpdatePatientReferralMutation,
  useRestorePatientReferralMutation,
  useBulkRestoreReferrelPatientsMutation,
  useDeletePatientReferralMutation,
//   usefetchReferredReferrelPatientsAllQuery,
  useBulkDeleteReferrelPatientsMutation,
  useDestroyPatientReferralMutation,
  useBulkDestroyReferrelPatientsMutation,
} = patientReferrelApi;
